import { ChartActions, ChartStateType } from './chartTypes';

const chartReducer = (state: ChartStateType, action: ChartActions): ChartStateType => {
    switch (action.type) {
        case 'SET_SELECTED_TRADE_PAIR':
            return {
                ...state,
                selectedTradePair: action.payload,
            };
        case 'SET_TV_WIDGET':
            return {
                ...state,
                tvWidget: action.payload,
            };
        case 'SET_IS_CHART_READY':
            return {
                ...state,
                isChartReady: action.payload,
            };
        case 'TOGGLE_ADVANCED_MODE':
            localStorage.setItem('advancedMode', String(!state.isAdvancedMode));

            return {
                ...state,
                isAdvancedMode: !state.isAdvancedMode,
            };
        case 'TOGGLE_FAVOURITE_MARKET':
            const newFavourites = state.favouriteMarkets.includes(action.payload)
                ? state.favouriteMarkets.filter((market) => market !== action.payload)
                : [...state.favouriteMarkets, action.payload];

            localStorage.setItem('favouriteMarkets', JSON.stringify(newFavourites));

            return {
                ...state,
                favouriteMarkets: newFavourites,
            };
        default:
            return state;
    }
};

export default chartReducer;
